import axios from "axios";
import React, { useState, useEffect, useCallback } from "react";
import { Modal, Button, Spinner, Table } from "react-bootstrap";
import { BASE_URL } from "../../../env";

const ViewJlgEmiPendingModal = ({
  show,
  handleClose,
  centerId,
  emiDate,
  croId,
  role,
}) => {
  const [reportData, setReportData] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchModalData = useCallback(async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${BASE_URL}/api/getJlgEmiPendingList`, {
        params: {
          manager_id: croId,
          role: "Customer Relationship Officer",
          selectedDate: emiDate,
          centerId,
        },
      });
      if (response.data.pendingEmiList) {
        setReportData(response.data.pendingEmiList);
        console.log(
          "reportData: " + JSON.stringify(response.data.pendingEmiList)
        );
      } else {
        setReportData([]);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }, [croId, emiDate, centerId]);

  useEffect(() => {
    if (show) {
      fetchModalData();
    }
  }, [fetchModalData, show]);

  // Group data by groupName
  const groupedData = reportData.reduce((groups, item) => {
    if (!groups[item.groupName]) {
      groups[item.groupName] = [];
    }
    groups[item.groupName].push(item);
    return groups;
  }, {});

  return (
    <Modal show={show} onHide={handleClose} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Members</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading ? (
          <div className="text-center py-4">
            <Spinner animation="border" role="status" variant="primary">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
            <p className="mt-2">Loading members data...</p>
          </div>
        ) : reportData.length > 0 ? (
          <div>
            {Object.entries(groupedData).map(([groupName, groupMembers]) => (
              <div key={groupName} className="mb-4">
                <h5 className="bg-light p-2 mb-2">Group: {groupName}</h5>
                <Table striped bordered hover responsive>
                  <thead>
                    <tr>
                      <th>Member Name</th>
                      <th>Pending EMI</th>
                      <th>Collected Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {groupMembers.map((item, index) => (
                      <tr key={item.memberId || index}>
                        <td>{item.memberName}</td>
                        <td>{item.pendingEmi}</td>
                        <td>{item.collectedEmi || 0}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center py-3">No pending EMI data found</div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ViewJlgEmiPendingModal;
